import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownload } from "@fortawesome/pro-light-svg-icons";
import ScrollTable from "./../../../components/ScrollTable/index";
import { LoaderWrapper } from "../../../components";
import { getExtension } from "../MapAndTransformOutput/MapAndTransformOutputContainer";
import { stringToFunctionConverter } from "../../../utils";
import { orderBy } from "lodash";
import { downloadSampleFixedWidthFile } from "../../../services";
import { useRouterParams } from "../../../abstracts";
import FileSaver from "file-saver";

const VerifyMapFixedWidthContainer = ({ fixedWidthObj, fileName, state }) => {
  var fileFormatExtenstion = getExtension(state?.api?.data?.format);
  var { profileId } = useRouterParams();
  var fileName = stringToFunctionConverter(state?.api?.data?.fileName, 2);

  return (
    <div>
      <LoaderWrapper>
        <div className="d-flex justify-content-end mb-3">
          <FontAwesomeIcon
            icon={faCloudDownload}
            color="#333333"
            className="mr-3 ft-20 clickable"
            onClick={() => {
              downloadSampleFixedWidthFile(profileId).then((response) => {
                var blob = new Blob([response], {
                  type: "text/plain",
                });
                FileSaver.saveAs(
                  blob,
                  fileName?.toString()?.concat(fileFormatExtenstion)
                );
              });
            }}
          />
        </div>
        <div className="mb-3">
          <div className="mb-3">
            {fileName?.toString()?.concat(fileFormatExtenstion)}
          </div>
          {/* <small>{fixedWidthObj.length} Fields</small> */}
        </div>

        {fixedWidthObj.map((section, index) => {
          return (
            <>
              <div className="mb-3">
                <div className="bold ft-14">{section?.name}</div>
              </div>
              <ScrollTable
                header={null}
                body={orderBy(
                  section?.fixedWidthOutputSectionFields,
                  ["from"],
                  ["asc"]
                ).map((item) => stringToFunctionConverter(item?.value, 3))}
              />
            </>
          );
        })}

        {/* { true? <ScrollTable header={fixedWidthObj.map((item)=>{ return item.sectionName })} body ={fixedWidthObj.map((item)=>{ return item.data})}></ScrollTable> : 
                  <ScrollTable header={arrayObject.map((item)=>{ return item.header})} body ={arrayObject.map((item)=>{ return item.value})}></ScrollTable>} */}
      </LoaderWrapper>
    </div>
  );
};

export default VerifyMapFixedWidthContainer;
